const phoneRegExp = /09[0-9]{8}/;
const addressRegExp = /[0-9]+\D+/;
const nameRegExp = /^(?=.*[\u4e00-\u9fa5\u3400-\u4DBF\uF900-\uFAFFa-zA-Z])[\u4e00-\u9fa5\u3400-\u4DBF\uF900-\uFAFF_a-zA-Z,\s\u00B7\u2027-]{2,}$/;
const carLicensePlateExp = /(^[0-9A-Z]{4}-[0-9A-Z]{3}$)|(^[0-9A-Z]{3}-[0-9A-Z]{4}$)|(^[0-9A-Z]{2}-[0-9A-Z]{4}$)|(^[0-9A-Z]{4}-[0-9A-Z]{2}$)/
const motorLicensePlateExp = /(^[0-9A-Z]{3}-[0-9A-Z]{3}$)|(^[0-9A-Z]{4}-[0-9A-Z]{3}$)|(^[0-9A-Z]{3}-[0-9A-Z]{4}$)/

export { phoneRegExp, addressRegExp, nameRegExp, carLicensePlateExp, motorLicensePlateExp };
